import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Box from '@mui/material/Box';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Notification = ({ is_open, messageType, handleClose, messages }) => {
  return (
    <Snackbar 
      autoHideDuration={4000} 
      open={is_open} 
      onClose={handleClose} 
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert severity={messageType} sx={{ width: '100%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          {/* Handle Array of Strings */}
          {messages && 
           messages.length !== 0 && 
           typeof messages[0] !== "object" && 
           messages.map((value, index) => (
              <div key={`msg-str-${index}`} style={{ fontWeight: index === 0 ? 'bold' : 'normal' }}>
                {value}
              </div>
           ))
          }

          {/* Handle Array of Objects (Error Field Logic) */}
          {messages && 
           messages.length !== 0 && 
           typeof messages[0] === "object" && 
           messages.map((item, index) => (
              <div key={`msg-obj-${index}`}>
                {item.error || item.reason || "Unknown Error"}
              </div>
           ))
          }
        </Box>
      </Alert>
    </Snackbar>
  );
}

export default Notification;